import { fetcher } from '@commenda/utils';

export async function deleteComplianceItem(
  complianceId: string,
  nextAuthToken: string
): Promise<boolean> {
  const res = await fetcher(
    `compliance/${complianceId}`,
    { method: 'DELETE' },
    nextAuthToken
  );

  if (!res.ok) {
    return false;
  }

  return true;
}
